export const isString = (a: unknown): a is string => typeof a === 'string';

/**
 * a includes b (with case insensitive matching)
 */
export function includesCaseInsensitive(
  a: string = '',
  b: string = '',
): boolean {
  return (
    [a, b].every(isString) &&
    (!b || a.toLowerCase().indexOf(b.toLowerCase()) !== -1)
  );
}

export const StringUtils = {
  includesCaseInsensitive,
};
